var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileCsvInner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 38,
    viewBox: "0 0 67 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45.9206V4.17582H0V0Z",
    transform: "translate(20.9199 12.6399) scale(1 -1)",
    fill: "#556080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45.9206V4.17582H0V0Z",
    transform: "translate(20.9199 20.99) scale(1 -1)",
    fill: "#556080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H66.7936V4.17582H0V0Z",
    transform: "translate(0.0400391 29.3399) scale(1 -1)",
    fill: "#556080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H50.0952V4.17582H0V0Z",
    transform: "translate(0.0400391 37.69) scale(1 -1)",
    fill: "#556080"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6984 0V3.69705H10.5309V20.8791H6.19547V3.69705H0V0H16.6984Z",
    transform: "translate(0.0400391 0.109863)",
    fill: "#556080"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45.9206V4.17582H0V0Z",
    transform: "translate(20.9199 4.28006) scale(1 -1)",
    fill: "#556080"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCsvInner);
export default __webpack_public_path__ + "static/media/file-csv-inner.e8aaee8a3ea589de64e1214f9f9d95fb.svg";
export { ForwardRef as ReactComponent };